import React from 'react';

import SesamLink from '../common/Links/SesamLink';
import { Form, FormActions } from '../common/forms';

import type { ConnectSubscriptionStatus } from 'src/types/subscription.types';

export const UnknownReasonMessage: React.FC<{ connectStatus: ConnectSubscriptionStatus }> = ({
  connectStatus,
}) => (
  <div title="Oops, unable to connect">
    <h2 className="connect-message-title">Oops, unable to connect</h2>
    <p>
      Failed to connect for an unknown reason:{' '}
      <code className="connection-string">{connectStatus}</code>.
    </p>
    <Form component="div">
      <FormActions>
        <SesamLink to={`/dashboard`}>Go to dashboard</SesamLink>
      </FormActions>
    </Form>
  </div>
);
